<template>
	<div id="checkbox">
		<div v-for="option in item.options" :key="option.id">
			<input
				:type="item.inputType"
				:id="'option-' + option.id"
				:name="'option-' + item.id"
				:value="option.value"
				@change="checkboxChanged($event)"
			/>

			<label
				v-if="pageId == 1925"
				:for="option.id"
				class="pis-2 cursor-pointer"
				@click="openTerms"
			>
				{{ option.name }}
			</label>

			<label v-else-if="pageId == 2020" :for="option.id" class="pis-2">
				Con tu consentimiento, las cookies se utilizan para mejorar tu
				experiencia en la web y para integrarla con redes sociales.
				Nosotros y terceros podremos rastrear tu comportamiento en
				nuestro sitio web y otras cuestiones similares. En función de
				esto, el sitio web de Heineken España podrá mostrarte anuncios
				adaptados a tu interés y adaptar tu publicidad en base a un
				perfil segmentado.
				<a
					href="https://unmundodecervezas.com/legales/HESA_Politica_de_Cookies.pdf"
					target="_blank"
				>
					Lee más
				</a>
				.
			</label>

			<label v-else :for="option.id" class="pis-2">
				{{ option.name }}
			</label>
		</div>
	</div>
</template>

<script>
import { EventBus } from "@/event-bus.js";

export default {
	name: "Checkbox",
	props: ["value", "item"],
	events: ["input"],
	computed: {
		pageId() {
			return this.$store.getters.pageId;
		},
		vModelProxy: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
			},
		},
	},
	methods: {
		checkboxChanged(e) {
			let checkedValues = this.vModelProxy;

			if (checkedValues === undefined || checkedValues === null)
				checkedValues = [];

			if (e.target.checked) {
				// Don't add the option if it was already present
				if (!checkedValues.includes(e.target.value))
					checkedValues.push(e.target.value);
			} else {
				// Remove option
				const index = checkedValues.indexOf(e.target.value);
				if (index > -1) checkedValues.splice(index, 1);
			}

			this.vModelProxy = checkedValues;
		},
		openTerms(e) {
			e.stopPropagation();

			EventBus.$emit("open-terms");
		},
	},
};
</script>